import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export const PageShell = ({ children }) => (
  <div className="min-h-screen bg-ink-900 text-white flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export default PageShell;
